import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/promo"

export const List = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};

export const Add = async (values) => {
  return await axiosInstance(options).post(`${path}/create`, values);
};

export const Edit = async (values) => {
  return await axiosInstance(options).put(`${path}/update`, values);
};

export const Delete = async (id) => {
  return await axiosInstance(options).delete(`${path}/delete?_id=${id}`);
};

export const Details = async (id) => {
  return await axiosInstance(options).get(`${path}/details?_id=${id}`);
};

export const Status = async (values) => {
  return await axiosInstance(options).post(`${path}/change-status`, values);
};







